import axios from "axios";
import {
  isNetworkOrServerError,
  markBackendReachable,
  markBackendUnreachable,
} from "./apiConnectivity";

// Authenticated API Client: Token required
export const queueApiClient = axios.create({
  baseURL: import.meta.env.VITE_AUTHENTICATION_API,
  timeout: 100000,
});

// Request interceptor for queueApiClient
queueApiClient.interceptors.request.use((config) => {
  const updatedConfig = { ...config };
  const token = localStorage.getItem("authToken");
  const queueApiUrl = localStorage.getItem("queueAPI");
  
  // Use JWT's API endpoint if available, otherwise fall back to environment default
  if (queueApiUrl) {
    updatedConfig.baseURL = queueApiUrl;
  } else {
    // Fall back to environment default
    updatedConfig.baseURL = import.meta.env.VITE_AUTHENTICATION_API;
  }

  if (token) {
    updatedConfig.headers.Authorization = `Bearer ${token}`;
  }
  return updatedConfig;
}, Promise.reject);

queueApiClient.interceptors.response.use(
  (response) => {
    markBackendReachable();
    return response;
  },
  (error) => {
    if (isNetworkOrServerError(error)) {
      markBackendUnreachable();
    }
    return Promise.reject(error);
  },
);

// queueApiClient.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     console.log("Error received:", error.code, error.message, error.response);
//     // If there is no response (network error, server down) or server error (5xx)
//     if (
//       !error.response ||
//       (error.response.status >= 500 && error.response.status < 600)
//     ) {
//       // Prevent infinite redirect loop
//       if (window.location.pathname !== "/error") {
//         window.location.replace("/error");
//       }
//     }
//     return Promise.reject(error);
//   }
// );
const { get, post, put, patch, delete: destroy } = queueApiClient;
export { get, post, put, patch, destroy };
